export default __webpack_public_path__ + "locales/zh-CN/SalesDepartmentRequestDialog.json?hash=d20fa68d1f03ba064ec54da4600f4478";